import React from 'react'

// ------------------swiper------------------
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import { FreeMode, Pagination } from 'swiper/modules';
import { CategorymCardData } from '../data/categoryData';

const CategoryCardSwiper = ({ selectedCategory, setSelectedCategory }) => {
    return (
        <div className='w-100'>
            <Swiper
                slidesPerView={'auto'}
                spaceBetween={1}
                freeMode={true}
                modules={[FreeMode, Pagination]}
                style={{ height: "auto", padding: "0 16px" }}
            >
                {CategorymCardData && CategorymCardData.map((card) => {
                    const isActive = selectedCategory === card.title;
                    return (
                        <SwiperSlide
                            className={`category_card_wrapper item_center ${isActive ? 'active' : ''}`}
                            key={card.id}
                            onClick={() => setSelectedCategory(card.title)}
                        >
                            <div className={`category_card item_center ${isActive ? 'active-card' : ''}`}>
                                <img className='img-fluid category_img' src={card.cardImage} alt={card.title} />
                            </div>
                            <p className={`category_card_title ${isActive ? 'fw-semibold text-white' : ''}`}>{card.title}</p>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </div>
    )
}

export default CategoryCardSwiper